module.exports = __webpack_public_path__ + "static/media/location.3ea4aee2.svg";